import { ApiConfig, BaseApiClient } from '../types/api';
import { tokenStorage } from '../utils/token-storage';

/**
 * Base API Client
 * Provides common functionality for all API clients
 */
export class CamionNetBaseApiClient implements BaseApiClient {
  protected baseUrl: string;
  protected version: string;

  constructor(config: ApiConfig) {
    this.baseUrl = config.baseUrl;
    this.version = config.version;
  }

  /**
   * Helper method to add version header to all requests
   */
  public getHeaders(contentType = 'application/json'): HeadersInit {
    const headers: HeadersInit = {
      'Content-Type': contentType,
      version: this.version,
    };

    // Add JWT token to headers if available
    const token = tokenStorage.getToken();
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    return headers;
  }

  /**
   * Generic request method with error handling
   */
  public async request<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
    const url = `${this.baseUrl}${endpoint}`;

    try {
      const response = await fetch(url, {
        ...options,
        headers: {
          ...this.getHeaders(),
          ...options.headers,
        },
      });

      if (!response.ok) {
        throw new Error(`API error: ${response.status} ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error(`Request failed for ${url}:`, error);
      throw error;
    }
  }
}
